import { orgAPI } from "@/api/api";
import { IntegrationConnection } from "@cohesive/api-client";
import {
  GoogleDriveFileEntity,
  GoogleDriveFileListInput,
  GoogleDriveFolderEntity,
} from "@cohesive/api-entities";
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";

export function useGoogleDriveFilesList(
  connection: IntegrationConnection,
  input: GoogleDriveFileListInput,
) {
  return useQuery({
    queryKey: ["google-drive-files-list", connection.id, input],
    queryFn: () => {
      return orgAPI.toolbox.execute<
        (GoogleDriveFileEntity | GoogleDriveFolderEntity)[]
      >({
        integration_connection_id: connection.id,
        action_name: "google-drive-files-list",
        action_input: input,
      });
    },
    enabled: !!connection.id,
  });
}

export function useGoogleDriveFilesListInfinite(
  connection: IntegrationConnection,
  input: GoogleDriveFileListInput,
) {
  return useInfiniteQuery({
    queryKey: ["google-drive-files-list-infinite", connection.id, input],
    queryFn: ({ pageParam = {} }) => {
      return orgAPI.toolbox.execute<
        (GoogleDriveFileEntity | GoogleDriveFolderEntity)[]
      >({
        integration_connection_id: connection.id,
        action_name: "google-drive-files-list",
        action_input: {
          ...input,
          ...pageParam,
        },
        // Typed entities drive the rich row UI; their generic projections ride
        // along in data_generic and are what get placed on the canvas.
        entity_format: "both",
      });
    },
    getNextPageParam: (lastPage) => lastPage.pagination?.next,
    initialPageParam: {},
    enabled: !!connection.id,
    staleTime: 5 * 60 * 1000, // 5 minutes - keep data fresh but reduce unnecessary refetches
    gcTime: 10 * 60 * 1000, // 10 minutes - keep in cache longer for better UX
    refetchOnWindowFocus: false, // Don't refetch when user switches tabs
  });
}
